var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      staticStyle: { "margin-left": "5px" },
      attrs: { placement: "right", width: "400", trigger: "manual" },
      model: {
        value: _vm.showBatchContract,
        callback: function ($$v) {
          _vm.showBatchContract = $$v
        },
        expression: "showBatchContract",
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "custom-form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": "right",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "合同状态", prop: "zt" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.zt,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "zt", $$v)
                    },
                    expression: "form.zt",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("未审")]),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("已审")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer", staticStyle: { float: "right" } },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.handleClose } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-button",
        {
          attrs: { slot: "reference", size: "small", type: "warning" },
          on: { click: _vm.handleClick },
          slot: "reference",
        },
        [_vm._v("批量审核合同")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }